$(function () {
  unify('.contact-blocks .inner');

  $(window).on('resize',function () {
    unify('.contact-blocks .inner');
  })
})
